import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { LABEL_POSITION, TEXTFIELD_VARIANT, TEXTFIELD_SIZE } from './TextField.constants.js';
import { getHoverBgColour, getFocusBgColour, getBgColour, getTypography, getBorderRadius, getSize } from './TextField.utils.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var InputBase = styled.input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  &:focus {\n    background-color: ", ";\n    border: ", ";\n    outline: none;\n    box-shadow: ", ";\n  }\n  &::selection {\n    background-color: ", ";\n    border: ", ";\n    color: ", ";\n  }\n  background-color: ", ";\n  color: ", ";\n  &::-webkit-calendar-picker-indicator {\n    color-scheme: ", ";\n  }\n"])), function (props) {
  return !props.disabled && "&:hover {\n      background-color: ".concat(getHoverBgColour(props), ";\n      border-color: ").concat(props.$errorMessage ? props.theme.colours.messaging.error.main : 'transparent', ";\n      box-shadow: ").concat(props.theme.effects.dropShadow.regular, ";\n    }");
}, function (_ref) {
  var $errorMessage = _ref.$errorMessage,
    theme = _ref.theme;
  return $errorMessage && "border: ".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.messaging.error.main, ";");
}, getFocusBgColour, function (_ref2) {
  var theme = _ref2.theme,
    $errorMessage = _ref2.$errorMessage;
  return "".concat(theme.sizing.xxtiny, " solid ").concat($errorMessage ? theme.colours.messaging.error.main : theme.colours.canvas.primary.main);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.effects.dropShadow.regular;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colours["interface"].main;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.primary.main);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colours["interface"].ink;
}, getBgColour, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colours.ink.primary.main;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.isDark ? 'dark' : 'light';
});
var Container = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  ", "\n  ", "\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colours.ink.primary.main;
}, function (_ref10) {
  var theme = _ref10.theme,
    $labelPosition = _ref10.$labelPosition;
  return $labelPosition === LABEL_POSITION.TOP ? "\n        flex-direction: column;\n        align-items: start;\n      " : "gap: ".concat(theme.sizing.tiny, ";");
}, function (_ref11) {
  var $variant = _ref11.$variant;
  return $variant !== TEXTFIELD_VARIANT.TERTIARY && 'width: 100%;';
});
var TextFieldLabel = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  ", "\n  ", "\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.colours.ink.primary.main;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.headingMedium;
}, function (_ref14) {
  var $labelPosition = _ref14.$labelPosition,
    $size = _ref14.$size;
  return ($labelPosition === LABEL_POSITION.NONE || $size === TEXTFIELD_SIZE.TINY) && 'display: none;';
});
var InputContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  width: 100%;\n\n  & > button {\n    position: absolute;\n    right: 0.3125rem;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"])));
var StyledInput = styled(InputBase)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  &:hover {\n    cursor: ", ";\n  }\n  &::-webkit-calendar-picker-indicator {\n    ", "\n  }\n  align-items: center;\n  border-radius: ", ";\n  display: flex;\n  justify-content: space-between;\n  margin: 0;\n  height: ", ";\n  padding: ", ";\n  ", ";\n  text-overflow: ellipsis;\n  overflow: none;\n  white-space: nowrap;\n  width: 100%;\n  ", ";\n"])), function (_ref15) {
  var theme = _ref15.theme,
    $size = _ref15.$size;
  return getTypography($size, theme.typography);
}, function (_ref16) {
  var disabled = _ref16.disabled;
  return disabled ? '' : 'text';
}, function (_ref17) {
  var $shouldDisplayCustomAdornment = _ref17.$shouldDisplayCustomAdornment;
  return $shouldDisplayCustomAdornment && 'display: none;';
}, function (_ref18) {
  var $size = _ref18.$size,
    theme = _ref18.theme;
  return getBorderRadius($size, theme.borderRadius);
}, function (_ref19) {
  var $size = _ref19.$size,
    theme = _ref19.theme;
  return getSize(theme, $size);
}, function (_ref20) {
  var theme = _ref20.theme;
  return "0 ".concat(theme.sizing.small);
}, function (_ref21) {
  var $shouldDisplayCustomAdornment = _ref21.$shouldDisplayCustomAdornment,
    $size = _ref21.$size,
    theme = _ref21.theme;
  return $shouldDisplayCustomAdornment && "padding-right: ".concat(getSize(theme, $size), ";");
}, function (_ref22) {
  var theme = _ref22.theme,
    disabled = _ref22.disabled;
  return disabled && "opacity: ".concat(theme.opacity.disabled, ";");
});
var ErrorContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: start;\n  gap: ", ";\n  padding-top: ", ";\n"])), function (_ref23) {
  var theme = _ref23.theme;
  return theme.sizing.tiny;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.sizing.tiny;
});
var IconWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  color: ", ";\n"])), function (_ref25) {
  var theme = _ref25.theme;
  return theme.sizing.xtiny;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.colours.messaging.error.main;
});

export { Container, ErrorContainer, IconWrapper, InputBase, InputContainer, StyledInput, TextFieldLabel };
//# sourceMappingURL=TextField.styles.js.map
